import { DEBUG, DEPLOY_ENV, MOCK_PORT, MOCK_HOST, NODE_ENV } from '@base/constants'

import ModelAdapter from '@fe/easy-mocker/lib/modelAdapter'

import request from '../../../../utils/request'
import commonMappings from '../mapping/index'

// @ts-ignore
const { commonModel, partialModel } = new ModelAdapter<typeof commonMappings, unknown>({
  NODE_ENV,
  bizFlag: '383',
  DEBUG,
  DEPLOY_ENV,
  host: MOCK_HOST,
  port: Number(MOCK_PORT),
  requestModule: request,
  commonMappings,
  partialMappings: null,
}).exportModels()

export { commonModel, partialModel }
